import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProjectEditFormState } from './project-edit-form.reducer';

export const ProjectEditFormKey = 'projectEditForm';

export const getProjectEditFormState =
  createFeatureSelector<ProjectEditFormState>(ProjectEditFormKey);

export const getAnchorValidationCounts = createSelector(
  getProjectEditFormState,
  (state: ProjectEditFormState) => state.anchorValidationErrorCounts,
);

export const getProjectEditFormStatus = createSelector(
  getProjectEditFormState,
  (state: ProjectEditFormState) => state.status,
);

export const getAnchorValidationErrorsExist = (anchor: string) =>
  createSelector(getAnchorValidationCounts, (counts) =>
    Object.keys(counts).includes(anchor) ? counts[anchor] > 0 : false,
  );

export const getIsProjectEditFormInvalid = createSelector(
  getProjectEditFormStatus,
  (status) => status === 'INVALID',
);

export const getIsProjectFormDataStable = createSelector(
  getProjectEditFormState,
  (state) => state.dataStable,
);
